export default "__VITE_ASSET__26606a6a__"